module.exports = __webpack_public_path__ + "static/media/background.d9ad3301.png";